<template>
  <div class="customer-risk-tab-filters d-flex i-gap-sm">
    <filter-button
      v-for="filter in riskFilters"
      :key="filter.id"
      :filter="filter"
      :selected="selectedFilter?.id === filter.id"
      class="button-filter-risk"
      @filter-click="onSelectionChanged"
      :data-dd-action-name="`customers-view-risk-filter-button-${filter.id}`"
    />
  </div>
</template>

<script>
import { getAndSyncQueryParams, updateQueryParams } from '@/utils/queryParams';
import { InscribeEventsLogger, INSCRIBE_EVENTS } from '@/events-logger';
import FilterButton from '@/V2/components/filters/FilterButton';
import { mapActions } from 'vuex';

export default {
  components: {
    FilterButton,
  },
  data() {
    return {
      riskCounts: {},
      params: getAndSyncQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
      }),
    };
  },
  async mounted() {
    await this.loadCustomersRiskCounts();
  },
  computed: {
    selectedFilter() {
      const riskLevels = this.$route?.query?.customer_risk_levels || [];
      return (
        this.riskFilters?.find(
          (filter) =>
            filter.queryParam === riskLevels ||
            (Array.isArray(riskLevels) &&
              riskLevels.includes(filter.queryParam)),
        ) || this.riskFilters[0]
      );
    },
    riskFilters() {
      const getFilterSubtitle = (count) => {
        if (typeof count === 'undefined') {
          return 'Fetching customer data...';
        }
        if (count === 1) {
          return '1 customer';
        }
        return `${count} customers`;
      };
      return [
        {
          id: 'all',
          title: 'All Customers',
          subtitle: getFilterSubtitle(this.riskCounts.total),
          icon: 'small_solid_user_multiple',
          queryParam: '',
          label: 'high risk',
        },
        {
          id: 'low',
          title: 'Low Risk',
          subtitle: getFilterSubtitle(this.riskCounts?.low),
          icon: 'small_solid_check',
          queryParam: 'LOW',
          label: 'low risk',
        },
        {
          id: 'medium',
          title: 'Medium Risk',
          subtitle: getFilterSubtitle(this.riskCounts?.medium),
          icon: 'small_solid_alert_circle',
          queryParam: 'MEDIUM',
          label: 'medium risk',
        },
        {
          id: 'high',
          title: 'High Risk',
          subtitle: getFilterSubtitle(this.riskCounts?.high),
          icon: 'small_solid_alert_triangle',
          queryParam: 'HIGH',
          label: 'high risk',
        },
      ];
    },
  },
  watch: {
    '$route.fullPath': {
      handler: function (newFullPath) {
        this.params = getAndSyncQueryParams({
          fullPath: newFullPath,
          router: this.$router,
          store: this.$store,
        });
      },
    },
  },
  methods: {
    ...mapActions(['fetchCustomersRiskCounts']),
    async loadCustomersRiskCounts() {
      const res = await this.fetchCustomersRiskCounts();
      this.riskCounts = res.data;
    },
    onSelectionChanged(filter) {
      updateQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
        updates: {
          page: 1,
          customer_risk_levels: [filter.queryParam],
        },
      });
      InscribeEventsLogger.logEvent(INSCRIBE_EVENTS.CUSTOMERS_SEARCH_CLICKED, {
        itemName: `risk_filter_${InscribeEventsLogger.clearItemName(
          filter.queryParam || 'all',
        )}`,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.customer-risk-tab-filters {
  button {
    flex: 1 1 0px;
  }
}
</style>
